import { useGLTF } from "@react-three/drei";

export const content = {
  navbar: {
    name: "Blok74",
    logoSrc: "./images/logo.png",
    email: "mic@blok74.org",
  },
  //HOME
  home: {
    title: "Blok74",
    subtitle: "Urban Simulations",
    paragraph:
      "We help public bodies, research institutions and urban design practices with gamified web-based tools for urban planning, project communication and participative urban design.",
    blocks: [
      {
        tileColor: "#5e8449",
        path: "./models/hospital.glb",
      },
      {
        tileColor: "#888",
        path: "./models/industrial.glb",
      },
      {
        tileColor: "#5e8449",
        path: "./models/houses.glb",
      },
      {
        tileColor: "#888",
        path: "./models/corp.glb",
      },

      {
        tileColor: "#666",
        path: "./models/parking.glb",
      },
      {
        tileColor: "#5e8449",
        path: "./models/stadium.glb",
      },
      {
        tileColor: "#666",
        path: "./models/trains.glb",
      },
      {
        tileColor: "#5e8449",
        path: "./models/forest.glb",
      },
    ],
  },

  //PROJECTS
  categories: [
    {
      id: 0,
      title: "Digital Storytelling",
      description:
        "BLOK 74 reimagines digital storytelling with engaging and gamified web-based designs that bring your urban projects to life.",
    },
    {
      id: 1,
      title: "Web-based simulations",
      description:
        "BLOK 74 cleverly combines gamification with light, web based simulations. The interactive models are easy to use for communication, education and research purposes, displaying all the relevant spatial elements.",
    },
    {
      id: 2,
      title: "Board Games for Cities",
      description:
        "New levels of city building gaming approaches: 3D board games that intelligently respond to contemporary needs of citizens’ engagement and co-design, supported by digital tools.",
    },
  ],

  projects: [
    {
      title: "Urban Research Incubator",
      description:
        "A sim that lets you experience how different researchers on lighting, safety and security shape cities in Europe, Africa and Latin America.",
      videoSrc: "./videos/uri.mp4",
      buttonText: "Website",
      buttonURL: "https://urbanri.ethz.ch/",
    },
    {
      title: "Urban Soul",
      description:
        "BLOK74 is designing digital learning tools for the Urban Soul project, an initiative that brings people together across generations to combat urban loneliness through the creation of shared urban gardens.",
      videoSrc: "./videos/urban-soul.mp4",
      buttonText: "Read more",
      buttonURL: "./pdf/urban-soul.pdf",
      categories: [],
    },

    {
      title: "80 Years\n80 Seconds",
      description: "Interactive celebration of the founder of Aedes, Christine Feireiss.",
      videoSrc: "./videos/kf80.mp4",
      buttonText: "Website",
      buttonURL: "http://kristin-feireiss-80.com/",
      categories: [],
    },
    {
      title: "City Builder",
      description:
        "City Builder is an educational and research tool, developed in collaboration with Urban ThinkTank of the ETH Zurich. It focuses on testing extreme urban densities. The simulation invites players to transform simplified urban grids based on real cities like Sarajevo, New York and Madrid.",
      videoSrc: "./videos/city-builder.mp4",
      buttonText: "Try it out",
      buttonURL: "./projects/utt/index.html",
      categories: [],
    },
    {
      title: "Knowledge Region",
      description:
        "The reigon between Delft and The Hague is full of innovation potential, but how do we connect the dots? In this strategic urban planning  game, players become city-makers, researchers, entrepreneurs, and community voices. The goal: to transform the corridor into a thriving ecosystem where knowledge flows, people connect, and ideas take root.",
      videoSrc: "./videos/knowledge-region.mp4",
      buttonText: "Read more",
      buttonURL: "./pdf/knowledge-region-workshop.pdf",
      categories: [],
    },

    {
      title: "uTurn",
      description:
        "Munich is on the move, but how do we shift from car-dependence to smarter, sustainable mobility? In this game, players act as policymakers, commuters, business owners, and citizens navigating the city’s transport future.",
      videoSrc: "./videos/uTurn.mp4",
      buttonText: "",
      buttonURL: "",
      categories: [],
    },

    {
      title: "Panevezys Air Base",
      description:
        "What happens when a former air base becomes a canvas for the city’s future? Should it become a hub for green energy, a cultural hotspot, housing, or a mix of all? Players must negotiate, trade, and co-create the vision for tomorrow.",
      videoSrc: "./videos/panevezys.mp4",
      buttonText: "Read more",
      buttonURL: "https://www.mashstudio.eu/mokymai-darni-regeneracija",
      categories: [],
    },
    {
      title: "DUST Project",
      description:
        "We have developed a digital storytelling concept for the DUST project, documenting and communicating the resutls of a complex EU -funded reseaerch on just transitions of energy landscapes.",
      videoSrc: "./videos/dust.mp4",
      buttonText: "Website",
      buttonURL: "https://www.dustproject.eu/",
      categories: [],
    },

    {
      title: "Square Builders",
      description:
        "Turn the school streets into your game board: experiment, visualise, and win the best design award.",
      videoSrc: "./videos/square-builders.mp4",
      buttonText: "Read more",
      buttonURL: "./pdf/square-builders.pdf",
      categories: [],
    },

    {
      title: "Future Region Attert Wark",
      description:
        "Attert Wark Rural Renewal turns villages into a region-wide game board, revive, redesign, and discuss their future.",
      videoSrc: "./videos/attert.mp4",
      buttonText: "Read more",
      buttonURL: "./pdf/atert-urban-gaming-workshop.pdf",
      categories: [],
    },
    {
      title: "PDU de Conakry",
      description:
        "Digital impressions for the Conakry Mobility Plan project, an initiative aimed at introducing innovative mobility solutions across the city.",
      videoSrc: "./videos/pdu.mp4",
      buttonText: "Video",
      buttonURL: "https://www.youtube.com/watch?v=UwWYoAzAecQ",
      categories: [],
    },
    {
      title: "Urban Resillience Rotterdam West",
      description:
        "Rotterdam West Harbour as a testing ground for building a resilient neighborhood! In this interactive game, players face real-life challenges like flooding, heatwaves, housing pressure, and cultural diversity. The game is rooted in real issues, and helps residents, planners, and students imagine futures where Rotterdam West thrives.",
      videoSrc: "./videos/urban-resilience.mp4",
      buttonText: "Read more",
      buttonURL: "./pdf/urban-resilience.pdf",
      categories: [],
    },
  ],

  //TEAM
  team: [
    {
      name: "Milena Ivković",
      description:
        "Milena is a Dutch-Serbian architect, urban designer, and digital artist. Combining her expertise in urban form and co-design, she works to create inclusive and inspiring public spaces shaped together with the communities that use them. Her approach merges design and participation to make cities more sustainable, vibrant, and human-centered.",
      imgSrc: "./images/team/milena.png",
    },
    {
      name: "Stefan Nikolić",
      description:
        "Stefan is a Serbian programmer and game designer who explores how game mechanisms can enrich everyday life. He develops serious games that engage players in reflection, learning, and collaboration.",
      imgSrc: "./images/team/stefan.png",
    },
  ],

  //CLIENTS
  clients: [
    {
      name: "ETH Zurich",
      logoSrc: "./images/clients/eth.png",
      keepPosition: true,
    },
    {
      name: "ISTP",
      logoSrc: "./images/clients/istp.png",
      keepPosition: true,
    },
    {
      name: "Citilinks",
      logoSrc: "./images/clients/citilinks.png",
    },
    {
      name: "TU Delft",
      logoSrc: "./images/clients/tu-delft.png",
    },
    {
      name: "Isocarp",
      logoSrc: "./images/clients/isocarp.png",
    },
    {
      name: "Mash Studio",
      logoSrc: "./images/clients/mash-studio.png",
    },
    {
      name: "Erasmus+",
      logoSrc: "./images/clients/erasmus.png",
    },
    {
      name: "Institute for Urban Excellence",
      logoSrc: "./images/clients/iue.png",
    },
    {
      name: "European Commission",
      logoSrc: "./images/clients/eu-commission.png",
    },

    {
      name: "Veld Academie",
      logoSrc: "./images/clients/veld.png",
    },
    {
      name: "Aedes",
      logoSrc: "./images/clients/aedes.png",
    },
    {
      name: "Intrestik",
      logoSrc: "./images/clients/intrestik.png",
    },
    {
      name: "Architekturzentrum Wien",
      logoSrc: "./images/clients/azw.png",
    },
  ],

  //FOOTER
  footer: {
    address: {
      company: "Blok 74",
      street: "Calandstraat 45D",
      city: "3016 CA Rotterdam",
      country: "Netherlands",
      mapURL: "https://maps.app.goo.gl/Ky3b6kaovYG4aqzi9",
    },
    chamberOfCommerce: "52587746",
    email: "mic@blok74.org",
    instagramURL: "https://www.instagram.com/milena_b74/",
    linkedInURL: "https://www.linkedin.com/company/blok-74-urban-simulations-urban-communications",
    facebookURL: "https://www.facebook.com/BLOK74sims/",
  },
};

// Preload all GLTF models used in the home section
content.home.blocks.forEach((block) => {
  useGLTF.preload(block.path);
});
